<template>
  <Dropdown
    v-model="selectedShow"
    :options="filteredShowsList"
    option-label="show_title"
    option-value="show_id"
    placeholder="All Shows"
    class="tw-border-none tw-outline-none tw-shadow-none tw-bg-none tw-bg-transparent tw-items-center tw-max-w-full sm:tw-max-w-72"
    input-class="tw-text-3xl md:tw-text-[40px] tw-font-light tw-p-0 tw-leading-normal"
    panel-class="tw-max-w-xs md:tw-max-w-sm"
    filter
    @change="emits('selectShow', selectedShow)"
  >
  </Dropdown>
</template>

<script setup>
import Dropdown from "primevue/dropdown";
import { computed, ref, onMounted, watch } from "vue";
import { useStore } from "vuex";

const props = defineProps({
  selectedPodcaster: {
    type: [String, Number],
    default: "all",
  },
  hostingFilter: {
    type: String,
    default: "all",
  },
});
const emits = defineEmits(["selectShow"]);

const store = useStore();
const token = localStorage.getItem("networkAdminToken");
const selectedShow = ref("all");

watch(
  () => props.selectedPodcaster,
  () => {
    selectedShow.value = "all";
  }
);

watch(
  () => props.hostingFilter,
  () => {
    selectedShow.value = "all";
  }
);

const filteredShowsList = computed(() => {
  let allNetworkShows = store.getters.shows || [];

  if (props.selectedPodcaster !== "all") {
    allNetworkShows = allNetworkShows.filter(
      (show) => show.podcaster_id == props.selectedPodcaster
    );
  }

  if (props.hostingFilter && props.hostingFilter !== "all") {
    allNetworkShows = allNetworkShows.filter(
      (show) =>
        show.hosted &&
        show.hosted.toLowerCase() === props.hostingFilter.toLowerCase()
    );
  }

  return [{ show_id: "all", show_title: "All Shows" }, ...allNetworkShows];
});

onMounted(() => {
  if (!store.getters.shows || store.getters.shows.length === 0) {
    store.dispatch("loadShows", { token });
  }
});
</script>
